import { formatNumber } from '@/utils/string.utils';
import { DEFAULT_CURRENCY } from 'common/constants/billing.constants';

/**
 * THE money formatter — the only place a currency symbol is ever produced. EUR keeps the two
 * historical house styles byte-for-byte (`144€` / spaced `144 €`, cents hidden on round amounts);
 * every other currency renders via Intl for the market-aware locale (de-CH → "CHF 144.50"), so new
 * markets format correctly with zero code changes.
 */
export function formatAmount(
  amountCents: number,
  currency: string,
  options: { alwaysShowCents?: boolean; spaced?: boolean } = {},
): string {
  const showCents = options.alwaysShowCents || amountCents % 100 !== 0;

  if (currency.toLowerCase() === DEFAULT_CURRENCY) {
    const amount = formatNumber(amountCents / 100, {
      minimumFractionDigits: showCents ? 2 : 0,
      maximumFractionDigits: 2,
    });
    return options.spaced ? `${amount} €` : `${amount}€`;
  }

  return formatNumber(amountCents / 100, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

export function formatBillingAmount(amountCents: number, currency?: string | null): string {
  return formatAmount(amountCents, currency ?? DEFAULT_CURRENCY);
}
